import React from 'react';
import FeatureVideoCard, { FeatureItem } from './FeatureVideoCard';
import styles from './FeaturesVideoSection.module.css';

type FeaturesVideoSectionProps = {
  title?: string;
  subtitle?: string;
  items?: FeatureItem[];
};
const DEFAULT_FEATURES: FeatureItem[] = [
 
  {
    title: 'going up',
    youtubeUrl: 'https://www.youtube.com/embed/paoJnN1T6Ss',
  },
  {
    title: 'up the building ',
    youtubeUrl: 'https://www.youtube.com/embed/Nz-kF2dIN1c',
  },
  {
    title: 'THE B.A.T.',
    youtubeUrl: 'https://www.youtube.com/embed/fOA50npyONw',
  },

  {
    title: 'SMALL ROOM CHALLENGE ',
    youtubeUrl: 'https://www.youtube.com/embed/7QmsFyPmojc',
  },
  {
    title: 'The Bus Challenge ',
    youtubeUrl: 'https://www.youtube.com/embed/bsqjGUATTio',
  },
  {
    title: 'THE ELEVATOR CHALLENGE',
    youtubeUrl: 'https://www.youtube.com/embed/cCFghDPdyY0',
  },
  {
    title: 'The Tunnel Challenge ',
    youtubeUrl: 'https://www.youtube.com/embed/SoeCcXoV1ME',
  },
  {
    title: 'SET THE SPACE',
    youtubeUrl: 'https://www.youtube.com/embed/SqGyGpxZobk',
  },
  
 
  {
    title: 'NATURE SAFE PLACE',
    youtubeUrl: 'https://www.youtube.com/embed/3I46VRHbZ44',
  },
];


const FeaturesVideoSection: React.FC<FeaturesVideoSectionProps> = ({
  title = 'Platform Features',
  subtitle = 'A safe Expert-Led VRET platform designed with variety of immersive environments.',
  items = DEFAULT_FEATURES,
}) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </header>
        <div className={styles.grid} aria-label={title}>
          {items.map((item) => (
            <FeatureVideoCard key={item.title} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesVideoSection;
